import gql from 'graphql-tag';

const USER_OTHER_SETTING_MSB = gql`
  query {
    getUserOtherSetting {
      user_timezone
      country_id
      role_code
      mystage_theme
      is_hide_mystage_record_message
    }
  }
`;

export {
  USER_OTHER_SETTING_MSB
};
